import React from 'react'
import CustomLink from './CustomLink'
import { rhythm } from '../utils/typography'
import { themeStyles, colors } from '../utils/theme'

export const styles = {
  button: {
    border: `2px solid white`,
    borderRadius: '3px',
    padding: '10px',
    fontSize: rhythm(1),
    fontFamily: 'sans-serif',
    fontWeight: '100',
    color: 'white',
    display: 'flex',
    flexDirection: 'row',
    flex: -1,
    transition: 'all 0.3s ease',
    backgroundColor: colors.brightBlue,
    textDecoration: 'none',
    ...themeStyles.shadow,
    ':hover': {
      color: 'white',
      backgroundColor: colors.brightBlue,
    },
  },
}

const Button = ({
  href,
  to,
  analyticsId,
  onClick,
  text,
  style,
  ...otherProps
}) => {
  var isExternal = false;
  if (to) {
    isExternal = to.includes('http')

  } else {
    console.log('invalid link sent to button component')
  }
  return (
    <div>
      {isExternal ? (
        <a
          href={to}
          target="_blank"
          onClick={onClick}
          css={{ flex: -1, display: 'flex', textDecoration: 'none', ...style }}
          {...otherProps}
        >
          <div css={styles.button}>
            <div>{text}</div>
          </div>
        </a>
      ) : (
        <CustomLink
          href={href}
          to={to}
          onClick={onClick}
          analyticsId={analyticsId}
          css={{ flex: -1, display: 'flex', textDecoration: 'none', ...style }}
          {...otherProps}
        >
          <div css={styles.button}>
            <div>{text}</div>
          </div>
        </CustomLink>
      )}
    </div>
  )
}

export default Button
